import { render } from "./hrm-employee-salary-history-modal.vue?vue&type=template&id=6816f468&scoped=true"
import script from "./hrm-employee-salary-history-modal.vue?vue&type=script&lang=js"
export * from "./hrm-employee-salary-history-modal.vue?vue&type=script&lang=js"

import "./hrm-employee-salary-history-modal.vue?vue&type=style&index=0&id=6816f468&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6816f468"]])

export default __exports__